import _merge from 'lodash/merge'
import taboola from './taboola'
import taboolaDefaults from './taboolaDefaults'

export default {
  'editionSettings': {
    'key': 'espnid-en',
    'site': 'espn',
    'language': 'en',
    'country': 'id',
    'domain': 'asia.espn.com',
    'editionSiteId': '41',
    'https': true
  },
  'navId': '29356878',
  'dictionarySection': 'espn',
  'javaLocale': {
    'language': 'en',
    'region': 'ID'
  },
  'dateTime': {
    'long': 'dddd MMMM d, yyyy',
    'medium': 'MMMM d, yyyy',
    'short': 'M/d',
    'timeFormat': 'h:mm',
    'firstDayOfWeek': 'Sunday',
    'timeZone': 'Etc/GMT',
    'defaultFormat': 'd MMM, yyyy',
    'timeZoneString': 'GMT',
    'timeZoneBucket': 'America/New_York',
    'MMM D, YYYY': 'D MMM, YYYY',
    'M/D/YYYY': 'D/M/YYYY',
    'MM/DD/YYYY': 'DD/MM/YYYY',
    'MMDDYYYY': 'DDMMYYYY',
    'MMMM Do YYYY': 'Do MMMM YYYY',
    'dddd, MMMM Do YYYY' : 'dddd, Do MMMM YYYY',
    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
    'M/D': 'D/M',
    'ddd, M/D': 'ddd, D/M',
    'MMMM D, YYYY': 'D MMMM YYYY',
    'dddd, M/D': 'dddd, D/M',
    'age': {
      'seconds': 's',
      'minutes': 'm',
      'hours': 'h',
      'days': 'd'
    }
  },
  'numberFormat': {
    'long': '#,###',
    'short': '###',
    'currency': '#,###.00',
    'percent': '#.00%'
  },
  'temperature': {
    'scale': 'celsius',
    'symbol': '&deg; C'
  },
  'sponsoredContentProviders': [ 'taboola', 'outbrain' ],
  'taboola': _merge({}, taboolaDefaults, taboola),
  'outbrain': {
    'enabled': true,
    'template': 'ESPNGlobal',
    'desktop': {
      'compliantId': 'AR_15',
      'nonCompliantId': 'AR_12'
    },
    'mobile': {
      'compliantId': 'MR_4',
      'nonCompliantId': 'MB_5'
    },
    'video': {
      'desktop': {
        'compliantId': 'AR_16'
      },
      'mobile': {
        'compliantId': 'MB_6'
      }
    },
    'recap': {
      'desktop': {
        'compliantId': 'AR_6',
        'nonCompliantId': 'AR_30'
      },
      'mobile': {
        'compliantId': 'MB_3',
        'nonCompliantId': 'MB_9'
      }
    },
    'team': {
      'desktop': {
        'compliantId': 'SB_1'
      },
      'mobile': {
        'compliantId': 'SB_1'
      }
    }
  },
  'omniture': {
    'enabled': true,
    'site': 'espnasia'
  },
  'chartBeat': {
    'enabled': true
  },
  'ads': {
    'disabled': false,
    'partnerAd': false,
    'dev-config': 22029728,
    'qa-config': 22029728,
    'prod-config': 22029728
  },
  'partnerModules': {
    'global': true,
    'nba': true,
    'womenbb': true,
    'golf': true,
    'endurance': true,
    'horse': true,
    'nascar': true
  },
  'sportBranding': [
    {
      'sport': 'cricket',
      'image': 'logo-uk-cricinfo',
      'url': null
    },
    {
      'sport': 'soccer',
      'image': 'logo-uk-fc',
      'url': null
    },
    {
      'sport': 'rugby',
      'image': 'logo-uk-scrum',
      'url': null
    },
    {
      'sport': 'ncaaw',
      'image': 'ESPNcom-powerby-espnw',
      'url': 'http://www.espnw.com'
    },
    {
      'sport': 'ncw',
      'image': 'ESPNcom-powerby-espnw',
      'url': 'http://www.espnw.com'
    },
    {
      'sport': 'wnba',
      'image': 'ESPNcom-powerby-espnw',
      'url': 'http://www.espnw.com'
    },
    {
      'sport': 'womenbb',
      'image': 'ESPNcom-powerby-espnw',
      'url': 'http://www.espnw.com'
    }
  ],
  'siteLogo': {
    'class': '',
    'featurePhone': {
      'name': 'espn-logo',
      'width': 45,
      'height': 11
    }
  },
  'meta': {
    'titleBranding': ' - ESPN',
    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for Football, NBA, NFL, Cricket, Rugby, Golf and more.',
    'defaultMetaImage': 'espn_red.png',
    'social': {
      'twitter': {
        'twitterId': '',
        'card': 'summary',
        'app_id_iphone': '317469184',
        'site': 'espn',
        'app_name_googleplay': 'ESPN',
        'app_id_googleplay': 'com.espn.score_center',
        'app_name_iphone': 'ESPN',
        'language': 'en'
      },
      'facebook': {
        'id': '116656161708917',
        'og_site_name': 'ESPN.com',
        'locale': 'en_US'
      }
    }
  },
  'appDetails': {
    'ios': {
      'id': '317469184',
      'name': 'ESPN',
      'deepLinkUrl': 'ios-app://317469184/sportscenter',
      'deepLinkUrlScheme': 'sportscenter'
    },
    'android': {
      'id': 'com.espn.score_center',
      'name': 'ESPN',
      'deepLinkUrl': 'android-app://com.espn.score_center/sportscenter',
      'deepLinkUrlScheme': 'sportscenter'
    }
  },
  'shop': {
    'enabled': false
  },
  'sportReplacements': {},
  'uriRewrites': {
    'urls': {
      'toEdition': {},
      'toEnglish': {}
    },
    'roots': {
      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
      '/oly/summer/cycling/': '/oly/summer/cycling/',
      '/college-football/': '/ncf/',
      '/football/club': '/soccer/team',
      '/football/': '/soccer/',
      '/racing/nascar/': '/nascar/',
      '/racing/': '/rpm/',
      '/mens-college-basketball/': '/ncb/',
      '/womens-college-basketball/': '/ncw/',
      '/womens-basketball/': '/womenbb/',
      '/olympics/': '/oly/',
      '/cycling/': '/cycling/',
      '/figure-skating/': '/oly/',
      '/college-sports/': '/ncaa/',
      '/gymnastics/': '/oly/',
      '/skiing/': '/oly/',
      '/horse-racing/': '/horse/',
      '/sports/womenbb/': '/womenbb/',
      '/sports/horse/': '/horse/',
      '/nba-summer-league/': '/nba/summerleague/',
      '/espn/rss/football/': '/espn/rss/soccer/'
    },
    'pathSegments': {
      'table': 'standings',
      'fixtures': 'schedule'
    },
    'paramKeys': {},
    'paramValues': {}
  },
  'betting': {
    'enabled': false
  },
  'ticketProvider': null,
  'showFavorites': true,
  'showMobileScoresLink': true,
  'favoriteSportsManagement': true,
  'showInsider': false,
  'showWatch' : true,
  'showCategory': true,
  'hideCategoryLinks': [
    600,
    1700
  ],
  'categorySettings': {
    'leagues': true,
    'athletes': true,
    'teams': true,
    'tags': true
  },
  'showFCContent': true,
  'showCricInfoContent': true,
  'cookieConsent': true,
  'scDeepLinking': true,
  'allowShortUrl': false,
  'allowPrintUrl': true,
  'allowUserAccountManagement': true,
  'nowFeed': true,
  'hasTickets': false,
  'searchUrl': 'http://search.espn.com/',
  'hasSearch': false,
  'gameSettings': {
    'topEventsId': 29357096,
    'promotedSoccerLeaguesCeId': 12032789,
    'showBroadcast': false
  },
  'fallback': {
  },
  'editionAlert': {
    'enabled': true,
    'text': 'You have come to the all new Asia edition, for other ESPN editions, click here.'
  },
  'feeds': {
    'googlenews': {
      'allowedContentTypes': [
        'Story',
        'HeadlineNews'
      ]
    }
  },
  'tier2NavIds': {
  },
  'tier3NavIds': {
  },
  'latestVideoCollectionId': 18749055,
  'videoAutoStart': {
    'index': false,
    'scoreboard': false
  },
  'useMongo': true,
  'activeSite': true,
  'countries': [
    {
      'name': 'Myanmar',
      'country-code': 'mm',
      'showHreflang': true
    },
    {
      'name': 'Laos',
      'country-code': 'la',
      'showHreflang': true
    },
    {
      'name': 'Thailand',
      'country-code': 'th',
      'showHreflang': true
    },
    {
      'name': 'Cambodia',
      'country-code': 'kh',
      'showHreflang': true
    },
    {
      'name': 'Vietnam',
      'country-code': 'vt',
      'showHreflang': true
    },
    {
      'name': 'Malaysia',
      'country-code': 'mt',
      'showHreflang': true
    },
    {
      'name': 'Indonesia',
      'country-code': 'id',
      'showHreflang': true
    },
    {
      'name': 'Taiwan',
      'country-code': 'tw',
      'showHreflang': true
    },
    {
      'name': 'Hong Kong',
      'country-code': 'hk',
      'showHreflang': true
    }
  ]
}



// WEBPACK FOOTER //
// ../app/lib/utils/editions/config/asia.js